import React from 'react'

const SocialIcons = () => {


    return (
        <div className="social">
            <ul className="social-icons">
                <li><a href="https://www.facebook.com/piyush.talele6491" target="_blank"><i className="icon ion-social-facebook" aria-hidden="true"></i></a></li>
                <li><a href="skype:piyush.talele123?chat" target="_blank"><i className="icon ion-social-skype" aria-hidden="true"></i></a></li>
                <li><a href="https://mail.google.com/mail/u/0/?fs=1&to=piyushtalele.6491@gmail.com&su=SUBJECT&body=BODY&tf=cm" target="_blank"><i className="icon ion-social-google" aria-hidden="true"></i></a></li>
                <li><a href="https://github.com/piyushtalele-6491" target="_blank"><i className="icon ion-social-github" aria-hidden="true"></i></a></li>
                <li><a href="https://www.linkedin.com/in/piyushtalele6491/" target="_blank"><i className="icon ion-social-linkedin" aria-hidden="true"></i></a></li>
                <li><a href="https://www.instagram.com/piyushtalele6491/" target="_blank"><i className="icon ion-social-instagram" aria-hidden="true"></i></a></li>
            </ul>
        </div>
    );
}


export default SocialIcons;